/**
 * ledgerMoney
 *
 * The one money formatter of the ledger, `en-US` currency style in the ledger's currency. With `unit` `'minor'` (the
 * default) `amount` is integer minor units, scaled by `ledgerMajorUnits`; with `'printed'` it is already major units,
 * a statement total as printed (`totalAsPrinted`), shown with the currency's digits and up to three more, so a
 * printed amount past the cent reads "$13.995" and a whole amount "$14.00". Consumers: every ledger table and review in react,
 * `ledgerProposalProblem` and `ledgerStatementOriginalTotalWords` here, and `ledgerStatementRefusalMessage` in
 * functions.
 */

import { ledgerMajorUnits } from './ledgerMajorUnits';

export const ledgerMoney = (amount: number, currency: string, unit: 'minor' | 'printed' = 'minor'): string => {
    const format = new Intl.NumberFormat('en-US', { style: 'currency', currency });
    if (unit === 'minor') return format.format(ledgerMajorUnits(amount, currency));
    const digits = format.resolvedOptions().maximumFractionDigits ?? 0;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits + 3,
    }).format(amount);
};
